/* global gtag */
import createAdapter from './createAdapter'
import { gaMeasurementId, ga4MeasurementId } from 'js/config'
import { getItem, setItem } from 'js/storeManager'

const gaAdapter = createAdapter(() => !!window.gtag, {
  page({ url, pathname, title }) {
    gtag('config', gaMeasurementId as string, {
      page_location: url,
      page_title: title,
      page_path: pathname,
    })
    gtag('config', ga4MeasurementId as string, {
      page_location: url,
      page_title: title,
      page_path: pathname,
    })
    const firstPage = getItem('FirstPage')
    if (!firstPage) {
      setItem('FirstPage')
      gtag('set', 'user_properties', {
        FirstPage: url,
      })
    }
  },
  track(eventAction, eventProperties = {}) {
    if (
      !Object.prototype.hasOwnProperty.call(eventProperties, 'eventCategory')
    ) {
      eventProperties['eventCategory'] = 'All'
    }
    eventProperties['eventAction'] = eventAction
    eventProperties['hitType'] = 'event'
    gtag('event', eventAction, eventProperties)
  },
  set(dimension, value) {
    gtag('set', dimension, value)
  },
  user(key, value) {
    gtag('set', 'user_properties', {
      [key]: value,
    })
  },
  virtualPageView(page) {
    gtag('config', gaMeasurementId as string, {
      page_path: page,
    })
  },
})

export { gaAdapter as ga }
